/**
 * Share
 *
 * @since 1.0.0
 */

const Share = () => {
  const buttons = document.querySelectorAll('.js-share')
  if (!buttons.length) return

  [...buttons].forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault()

      const {type} = this.dataset
      const href = window.location.href

      if (type === 'facebook') {
        openWindow(`https://www.facebook.com/sharer/sharer.php?u=${href}`)
      } else if (type === 'twitter') {
        openWindow(`http://twitter.com/share?url=${href}`)
      } else if (type === 'linkedin') {
        openWindow(`https://www.linkedin.com/shareArticle?mini=true&url=${href}`)
      }
    })
  })

  const openWindow = (url) => {
    window.open(url, '', 'width=450, height=250')
  }
}

export default Share



// WEBPACK FOOTER //
// ./src/js/modules/Share.js